import $http from "@/common/home-request.js"
import {jsonToUrl} from "@/common/util/url.util.js"


export function queryMapMsgOne() {
  let url = "info_config/getOne";
  return $http({
    url: url,
    method: 'get'
  });
}

export function saveOrupdateMapMsg(param) {
  let url = "info_config/saveOrUpdate";
  return $http({
    url: url,
    method: 'post',
    data: param
  });
}



//////////////////
// WEBPACK FOOTER
// ../manage-ui/src/views/mapmsg/api/map_msg.js
// module id = null
// module chunks = 